import React from 'react';
export const GHContext = /*#__PURE__*/React.createContext(props => /*#__PURE__*/React.createElement(React.Fragment, null, props.children));
export const RNSScreensRefContext = /*#__PURE__*/React.createContext(null);
//# sourceMappingURL=contexts.js.map